import { render } from "./basic-year-table.vue?vue&type=template&id=0a87a789&ts=true"
import script from "./basic-year-table.vue?vue&type=script&lang=ts"
export * from "./basic-year-table.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__